var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRtruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      transform: "rotate(-90deg)"
    },
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_66_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2C7.92339 2 3 6.92339 3 13C3 19.0766 7.92339 24 14 24C20.0766 24 25 19.0766 25 13C25 6.92339 20.0766 2 14 2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2C7.92339 2 3 6.92339 3 13C3 19.0766 7.92339 24 14 24C20.0766 24 25 19.0766 25 13C25 6.92339 20.0766 2 14 2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1248 12.994C20.1252 13.1499 20.0839 13.3031 20.0053 13.4377C19.9266 13.5723 19.8135 13.6834 19.6775 13.7596L10.4943 19.0102C10.3626 19.0849 10.2138 19.1244 10.0623 19.125C9.92273 19.1243 9.78537 19.0901 9.66168 19.0255C9.53798 18.9608 9.43155 18.8675 9.35127 18.7533C9.27098 18.6392 9.21917 18.5075 9.20016 18.3692C9.18115 18.2309 9.19549 18.0901 9.24199 17.9585L10.7185 13.5863C10.733 13.5435 10.7603 13.5063 10.7967 13.4796C10.8331 13.453 10.8769 13.4383 10.922 13.4375H14.8748C14.9348 13.4376 14.9941 13.4254 15.0492 13.4017C15.1043 13.3779 15.1538 13.343 15.1949 13.2993C15.2359 13.2555 15.2675 13.2038 15.2877 13.1474C15.3079 13.0909 15.3163 13.0309 15.3123 12.971C15.3024 12.8585 15.2503 12.7539 15.1666 12.6782C15.0828 12.6024 14.9735 12.5611 14.8606 12.5625H10.9231C10.8773 12.5625 10.8327 12.5482 10.7955 12.5215C10.7583 12.4948 10.7305 12.4571 10.7158 12.4138L9.23925 8.04203C9.18048 7.87447 9.17409 7.69299 9.22091 7.5217C9.26774 7.35041 9.36558 7.19742 9.50142 7.08306C9.63727 6.9687 9.80469 6.89838 9.98146 6.88143C10.1582 6.86449 10.336 6.90173 10.491 6.98821L19.6785 12.2322C19.8138 12.3082 19.9264 12.4188 20.0048 12.5527C20.0832 12.6865 20.1246 12.8388 20.1248 12.994Z",
    fill: "#FF4154"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_66_7",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_66_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_66_7",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtruck);
export default __webpack_public_path__ + "static/media/Rtruck.521364227e6721953045da2da9b98f09.svg";
export { ForwardRef as ReactComponent };